const isBrowser = typeof window !== "undefined";

const FIREBASE_CONFIG_DEV = {
  apiKey: "AIzaSyBEuj7HwvYAflbe4Dnqb8t9O3jp85Zy8zw",
  authDomain: "tujus-pwa-dev.firebaseapp.com",
  projectId: "tujus-pwa-dev",
  storageBucket: "tujus-pwa-dev.firebasestorage.app",
  messagingSenderId: "923999294142",
  appId: "1:923999294142:web:ff156f09a51901eaf004ef",
};

const FIREBASE_CONFIG_PROD = {
  apiKey: "AIzaSyB3knbbhomxzfaR8oeHPeLTpommgmU86gQ",
  authDomain: "tujud-pwa.firebaseapp.com",
  projectId: "tujud-pwa",
  storageBucket: "tujud-pwa.appspot.com",
  messagingSenderId: "491657812131",
  appId: "1:491657812131:web:c5ad7042aa118c3cf28716",
};

function pickFirebaseConfig(envSuffix, fallback) {
  return {
    apiKey:
      process.env[`REACT_APP_FIREBASE_API_KEY_${envSuffix}`] || fallback.apiKey,
    authDomain:
      process.env[`REACT_APP_FIREBASE_AUTH_DOMAIN_${envSuffix}`] ||
      fallback.authDomain,
    projectId:
      process.env[`REACT_APP_FIREBASE_PROJECT_ID_${envSuffix}`] ||
      fallback.projectId,
    storageBucket:
      process.env[`REACT_APP_FIREBASE_STORAGE_BUCKET_${envSuffix}`] ||
      fallback.storageBucket,
    messagingSenderId:
      process.env[`REACT_APP_FIREBASE_MESSAGING_SENDER_ID_${envSuffix}`] ||
      fallback.messagingSenderId,
    appId:
      process.env[`REACT_APP_FIREBASE_APP_ID_${envSuffix}`] || fallback.appId,
  };
}

function readBoolParam(name) {
  if (!isBrowser) return false;
  const v = new URLSearchParams(window.location.search).get(name);
  return v === "1" || v === "true";
}

function readStringParam(name) {
  if (!isBrowser) return null;
  return new URLSearchParams(window.location.search).get(name);
}

function readBoolStorage(key) {
  if (!isBrowser) return false;
  try {
    const v = window.localStorage.getItem(key);
    return v === "1" || v === "true";
  } catch {
    return false;
  }
}

export function computeIsDevEnvironment() {
  const forceDevFromUrl =
    readBoolParam("forceDev") || readStringParam("env") === "dev";
  const forceDevFromStorage =
    readBoolStorage("forceDev") || readBoolStorage("forceDevEnvironment");

  const host = isBrowser ? window.location.hostname : "";

  const hostIsDev =
    host === "tujus-pwa-dev.web.app" ||
    host.includes("ngrok") ||
    host === "localhost" ||
    host === "127.0.0.1";

  const buildSaysDev = process.env.REACT_APP_FIREBASE_ENV === "development";

  return forceDevFromUrl || forceDevFromStorage || hostIsDev || buildSaysDev;
}

export const isDevEnvironment = computeIsDevEnvironment();

export function getSentryDsn() {
  return isDevEnvironment
    ? process.env.REACT_APP_SENTRY_DSN_DEV
    : process.env.REACT_APP_SENTRY_DSN_PROD;
}

export const firebaseConfig = isDevEnvironment
  ? pickFirebaseConfig("DEV", FIREBASE_CONFIG_DEV)
  : pickFirebaseConfig("PROD", FIREBASE_CONFIG_PROD);

// experience-backend's Cloud Run URL for the dev Firebase project. Hardcoded
// as a fallback for the same reason firebaseConfig has one above: CRA's
// `npm run build` always embeds .env.production, never .env.development, no
// matter which hostname you're actually deploying to — so a build served
// from tujus-pwa-dev.web.app can easily end up with no
// REACT_APP_API_BASE_URL baked in at all, silently falling back to
// localhost:8080 (which a public site can't reach — browsers block that as
// a Local Network Access violation). Computing this from the hostname at
// runtime, like isDevEnvironment above, makes it correct regardless of
// which .env file happened to be loaded at build time.
const API_BASE_URL_DEV_FALLBACK = "https://experience-api-923999294142.us-central1.run.app";
const API_BASE_URL_PROD_FALLBACK = "https://experience-api-491657812131.us-central1.run.app";
const API_BASE_URL_LOCAL = "http://localhost:8080";

export function getApiBaseUrl() {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  const host = isBrowser ? window.location.hostname : "";
  if (host === "localhost" || host === "127.0.0.1") {
    return API_BASE_URL_LOCAL;
  }

  return isDevEnvironment ? API_BASE_URL_DEV_FALLBACK : API_BASE_URL_PROD_FALLBACK;
}
